<template>
    <el-table
        ref="elTable"
        v-loading="loading"
        :data="newTableData"
        :height="config.table.height"
        border
        width="100%"
        tooltip-effect="dark"
    >
        <el-table-column v-if="config.table.selectBtn" align="center" fixed="left" type="selection" :width="config.table.selectWidth || '50px'"></el-table-column>
        <!-- <el-table-column :width="50" align="center">
            <template slot-scope="scope">
                <i class="el-icon-view" @click="$emit('view-log', scope.row)"></i>
            </template>
        </el-table-column> -->
        <el-table-column
            v-for="(col, cIndex) in columnList"
            :key="col.prop + cIndex"
            :label="col.label"
            :prop="col.prop"
            :width="col.width"
            :sortable="col.sort"
            :align="col.align || 'left'"
            >
            <template slot-scope="scope">
                <template v-if="!col.type">{{ scope.row[col.prop] }}</template>
                <template v-else-if="col.type === 'select'">{{ dictData[col.optionNum][scope.row[col.prop]] }}</template>
                <template v-else-if="col.type === 'progress'">
                    <div class="progress">
                        <div v-for="(item, index) in scope.row[col.prop]" :key="index">
                            <i class="line" v-if="index > 0">-</i>
                            <el-tooltip placement="top">
                                <div slot="content">
                                    <span class="progress-label">{{ getProgressData(item.task).label }}</span><br/>
                                    <span class="progress-time">要求完成时间：{{ item.requiredCompletionTime }}</span>
                                </div>
                                <img :src="getProgressData(item.task).icon" alt="" class="progress-icon" />
                            </el-tooltip>
                        </div>
                    </div>
                </template>
                <template v-else>
                    {{ scope.row[col.prop] }}
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api.js';
import { adjustTableColumn } from './util.js';
export default {
    name: 'tableBox',
    props: {
        loading: { type: Boolean, default: false },
        config: {
            type: Object,
            default () {
                return {};
            }
        },
        tableData: {
            type: Array,
            default() {
                return [];
            }
        },
        columnLabelStr: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            newTableData: [],
            columnList: [],
            dictData: {},
            progressIconList: { // 任务(到车10，装车20，发车30，运抵50，签收60)
                10: {
                    icon: require('@/modules/transport/otp/assets/dc.png'),
                    label: '到车'
                },
                20: {
                    icon: require('@/modules/transport/otp/assets/zc.png'),
                    label: '装车'
                },
                30: {
                    icon: require('@/modules/transport/otp/assets/fc.png'),
                    label: '发车'
                },
                50: {
                    icon: require('@/modules/transport/otp/assets/yd.png'),
                    label: '运抵'
                },
                60: {
                    icon: require('@/modules/transport/otp/assets/qs.png'),
                    label: '签收'
                }
            }
        };
    },
    methods: {
        // 过滤数组空数据
        filterArrayNullValue(list) {
            const arr = [];
            list.forEach(v => v && arr.push(v));
            return arr.join(',');
        },

        // 数据字典
        getDictData() {
            const dictStr = this.filterArrayNullValue(this.config.table.columns.map(v => v.optionNum));
            dictWithUrl(dictStr).then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data || {};
                }
            });
        },

        // 获取进度图标信息
        getProgressData (task) {
            return this.progressIconList[task] ? this.progressIconList[task] : {};
        }
    },
    watch: {
        tableData: {
            handler(list) {
                this.newTableData = list;
            },
            immediate: true
        },
        columnLabelStr: {
            handler(columnListStr) {
                if (columnListStr) {
                    this.columnList = adjustTableColumn(columnListStr);
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.getDictData();
    }
};
</script>
<style scoped>
.el-icon-view {
    cursor: pointer;
    transition: color .2s;
}
.el-icon-view:hover {
    color: #00BCBF;
}
.progress, .progress > div {
    display: flex;
    align-items: center;
}
.progress-icon {
    width: 16px;
    display: inline-block;
}
.progress, .line {
    margin: 0 2px;
    color: #42a5fa;
}
</style>
